import React, {useState} from "react";
import MapComponentUx from "../shared/MapComponentUx";
import {ordersOverviewData, projectsTableData, statisticsCardsData, statisticsChartsData} from "../../../data";
import {StatisticsCard} from "../../../widgets/cards";
import {
    Avatar,
    Card, CardBody,
    CardHeader,
    IconButton,
    Menu,
    MenuHandler,
    MenuItem,
    MenuList, Progress, Tooltip,
    Typography
} from "@material-tailwind/react";
import SideNavUx from "../../layout/sidenav";
import NavBarUx from "../../layout/navbar";
import {StatisticsChart} from "../../../widgets/charts";
import {CheckCircleIcon, ClockIcon} from "@heroicons/react/24/solid";
import {ArrowUpIcon, EllipsisVerticalIcon} from "@heroicons/react/24/outline";
import FooterUx from "../layout/footer_ux";

const MapUX = (props) => {
    const [openSidenav, setOpenSidenav] = useState(false);
    const routes = {main: 'Mapa', current: 'Mapa'}

    return (
        <>
            <SideNavUx setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
            <div className="p-4 xl:ml-80">
                <NavBarUx routes={routes} setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
                <div className="mt-12">
                    <div className="mb-12 grid gap-y-10 gap-x-6 md:grid-cols-2 xl:grid-cols-4">
                        {statisticsCardsData.map(({icon, title, footer, ...rest}) => (
                            <StatisticsCard
                                key={title}
                                {...rest}
                                title={title}
                                icon={React.createElement(icon, {
                                    className: "w-6 h-6 text-white",
                                })}
                                footer={
                                    <Typography className="font-normal text-blue-gray-600">
                                        <strong className={footer.color}>{footer.value}</strong>
                                        &nbsp;{footer.label}
                                    </Typography>
                                }
                            />
                        ))}
                    </div>
                    <div className="flex flex-wrap">
                        <div className="w-full px-4">
                            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded h-600-px">
                                <MapComponentUx/>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterUx/>
            </div>
        </>
    );
};

export default MapUX;
